import { Navigate } from "react-router";
import { useGetShipmentQuery } from "../../../apis/Shipment.api";
import { PrimaryShipment, Shipment } from "../../../types/models/Shipment";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ShipmentScoped = () => {
    const {
        data,
    } = useGetShipmentQuery(PrimaryShipment.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/shipments/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ShipmentScoped;
